import { render, staticRenderFns } from "./roomsList.vue?vue&type=template&id=79158938&"
import script from "./roomsList.vue?vue&type=script&lang=js&"
export * from "./roomsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports